import { ChangeDetectorRef, DestroyRef, computed, inject, input, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { combineLatest, filter, map, merge, of, switchMap, take } from 'rxjs';
import { InstructionOutletDirective } from './instruction-outlet.directive';
import { UiFieldWrapperComponent } from '@common/ui/frontend-shared/field-wrapper';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
const _c0 = (a0, a1, a2, a3) => ({
  instruction: a0,
  formGroup: a1,
  formService: a2,
  formControlName: a3
});
function InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-field-wrapper", 1);
    i0.ɵɵtemplate(1, InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const localFormGroup_r1 = i0.ɵɵnextContext(2);
    const instruction_r2 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placeholder", instruction_r2.config.placeholder || null)("label", instruction_r2.config.label || null)("orientation", instruction_r2.config.orientation || "horizontal")("description", instruction_r2.config.description)("formGroup", localFormGroup_r1)("help", instruction_r2.config.help)("noInput", !instruction_r2.isInput);
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructionOutlet", i0.ɵɵpureFunction4(8, _c0, instruction_r2, localFormGroup_r1, ctx_r2.formService(), ctx_r2.localFormControlName()));
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 2);
    i0.ɵɵtemplate(1, InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const localFormGroup_r1 = i0.ɵɵnextContext(2);
    const instruction_r2 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", localFormGroup_r1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("instructionOutlet", i0.ɵɵpureFunction4(2, _c0, instruction_r2, localFormGroup_r1, ctx_r2.formService(), ctx_r2.localFormControlName()));
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_0_Template, 2, 13, "ui-field-wrapper", 1)(1, InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Conditional_1_Template, 2, 7, "ng-container", 2);
  }
  if (rf & 2) {
    const instruction_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(instruction_r2.useFieldWrapper ? 0 : 1);
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, InstructionOutletComponent_Conditional_0_Conditional_0_Conditional_0_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r2.displayState() ? 0 : -1);
  }
}
function InstructionOutletComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner", 0);
  }
  if (rf & 2) {
    i0.ɵɵproperty("inline", true);
  }
}
function InstructionOutletComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, InstructionOutletComponent_Conditional_0_Conditional_0_Template, 1, 1)(1, InstructionOutletComponent_Conditional_0_Conditional_1_Template, 1, 1, "ui-spinner", 0);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_2_0 = ctx_r2.localFormGroup()) ? 0 : 1, tmp_2_0);
  }
}
export let InstructionOutletComponent = /*#__PURE__*/(() => {
  class InstructionOutletComponent {
    get _hostClass() {
      return this.isPluginInstruction();
    }
    constructor(cd) {
      this.cd = cd;
      this.destroyRef = inject(DestroyRef);
      this.displayState = signal(true, ...(ngDevMode ? [{
        debugName: "displayState"
      }] : /* istanbul ignore next */[]));
      this.isPluginInstruction = computed(() => {
        return !!this.instruction()?.config.__pluginInstructionInfo;
      }, ...(ngDevMode ? [{
        debugName: "isPluginInstruction"
      }] : /* istanbul ignore next */[]));
      this.instruction = input(null, ...(ngDevMode ? [{
        debugName: "instruction"
      }] : /* istanbul ignore next */[]));
      this.inputForm = input(null, {
        ...(ngDevMode ? {
          debugName: "inputForm"
        } : /* istanbul ignore next */{}),
        alias: 'form'
      });
      // note: formService is optional. Either form or formService must be specified.
      // if formService is passed, conditional evaluators will receive full model.
      // otherwise they will receive the raw formGroup value.
      this.formService = input(null, ...(ngDevMode ? [{
        debugName: "formService"
      }] : /* istanbul ignore next */[]));
      this.baseFormGroup = computed(() => {
        const customFormGroup = this.inputForm();
        const formService = this.formService();
        if (customFormGroup) return customFormGroup;else if (formService) return formService.formGroup;else return null;
      }, ...(ngDevMode ? [{
        debugName: "baseFormGroup"
      }] : /* istanbul ignore next */[]));
      /**
       * Angular/forms does not support deep accessors inside directives like formControlName.
       * In order to make deep accessors work, we extract the simple formControlName + parent path,
       * get the appropriate formGroup from parent and assign them correctly.
       */
      this.isDeepAccessor = computed(() => {
        const config = this.instruction().config;
        const isDeepAccessor = config.formControlName?.includes('.') || false;
        return isDeepAccessor;
      }, ...(ngDevMode ? [{
        debugName: "isDeepAccessor"
      }] : /* istanbul ignore next */[]));
      this.localFormControlName = computed(() => {
        const config = this.instruction().config;
        if (this.isDeepAccessor()) {
          const splitted = config.formControlName.split('.');
          if (splitted.length > 2) throw new Error('deepAccessor currently only supports one layer of nesting! Deeper accessors need to be tested!');
          const formControlName = splitted.pop();
          return formControlName;
        } else {
          return config.formControlName;
        }
      }, ...(ngDevMode ? [{
        debugName: "localFormControlName"
      }] : /* istanbul ignore next */[]));
      this.localFormGroup = computed(() => {
        const baseFormGroup = this.baseFormGroup();
        if (!baseFormGroup) return null;
        const isDeepAccessor = this.isDeepAccessor();
        const config = this.instruction().config;
        if (isDeepAccessor) {
          const splitted = config.formControlName.split('.');
          splitted.pop();
          const formGroupName = splitted.join('.');
          return baseFormGroup.get(formGroupName);
        } else {
          return baseFormGroup;
        }
      }, ...(ngDevMode ? [{
        debugName: "localFormGroup"
      }] : /* istanbul ignore next */[]));
    }
    ngOnInit() {
      if (!this.inputForm() && !this.formService()) {
        throw new Error('InstructionOutletComponent error: Either form or formService must be passed in!');
      }
      const config = this.instruction().config;
      if (config.conditional) this.applyConditionalEvaluation(config);
    }
    /**
     * connect conditional logic where required
     */
    applyConditionalEvaluation(config) {
      // when this method is called, form value is not patched yet.
      // if we however wait for first formValue emission, this may cause flickering.
      // for that reason, we immediately apply default state if the Instruction uses conditional display.
      if (config.conditional?.display) this.displayState.set(false);
      this.getConditionalContext$(true).pipe(takeWhileAlive(this.destroyRef)).subscribe(value => {
        this.applyConditionalState(value, config);
      });
    }
    applyConditionalState(ctx, config) {
      const conditional = config.conditional;
      const mode = this.formService()?.getEditMode() || undefined;
      if (conditional.display) {
        this.displayState.set(conditional.display(ctx.model, ctx.editMode));
      }
      if (conditional.enable) {
        const enabledState = conditional.enable(ctx.model, ctx.editMode);
        const control = this.localFormGroup().get(this.localFormControlName());
        if (enabledState && !control.enabled) control.enable({
          onlySelf: true
        });else if (!enabledState && control.enabled) control.disable({
          onlySelf: true
        });
      }
      this.cd.markForCheck();
    }
    getConditionalContext$(includeReadonly = false) {
      const formService = this.formService();
      if (formService) {
        return formService.initializedValue$.pipe(filter(value => !!value), take(1)).pipe(switchMap(() => {
          // formValueChanges$ will not emit on form initialization.
          // so merge an emission of initial value into the observable
          return combineLatest({
            model: merge(of(formService.getValue(includeReadonly)), formService.formValueChanges$.pipe(map(value => {
              return includeReadonly ? formService.getValue(true) : value;
            }))),
            editMode: formService.getEditMode$()
          });
        }));
      } else {
        return this.baseFormGroup().root.valueChanges.pipe(map(model => {
          return {
            model,
            editMode: undefined
          };
        }));
      }
    }
    static {
      this.ɵfac = function InstructionOutletComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InstructionOutletComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: InstructionOutletComponent,
        selectors: [["instruction-outlet"]],
        hostVars: 2,
        hostBindings: function InstructionOutletComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("plugin-instruction", ctx._hostClass);
          }
        },
        inputs: {
          instruction: [1, "instruction"],
          inputForm: [1, "form", "inputForm"],
          formService: [1, "formService"],
          value: "value"
        },
        decls: 1,
        vars: 1,
        consts: [["label", "Initialisierung... warte auf FormGroup", 3, "inline"], [3, "placeholder", "label", "orientation", "description", "formGroup", "help", "noInput"], [3, "formGroup"], [4, "instructionOutlet"]],
        template: function InstructionOutletComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, InstructionOutletComponent_Conditional_0_Template, 2, 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.instruction()) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [UiFieldWrapperComponent, FormsModule, i1.NgControlStatusGroup, ReactiveFormsModule, i1.FormGroupDirective, InstructionOutletDirective, UiSpinnerComponent],
        styles: ["instruction-outlet+instruction-outlet{margin-top:14px;display:block}[_nghost-%COMP%]{display:block}.plugin-instruction[_nghost-%COMP%]{border-right:2px solid var(--secondaryColor)}\n\n/*# sourceMappingURL=instruction-outlet.component.ts-angular-inline--6.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return InstructionOutletComponent;
})();